export default __webpack_public_path__ + "static/media/bdswissReal_downloadMT4.be19a607.png";